<div class="call-log-details__ai">
  <table class="call-log-details__ai-table">
    <tbody>
      <tr>
        <th>
          <b>{{ "events.company-call-history.details.ai.headers.sentiment-score" | Translate }}</b>
        </th>
        <td>
          <ng-template
            [ngTemplateOutlet]="sentiment"
            [ngTemplateOutletContext]="{
              ai: aiData
            }">
          </ng-template>
        </td>
      </tr>
      <tr>
        <th>
          <b>{{ "events.company-call-history.details.ai.headers.summary" | Translate }}</b>
          <button
            class="call-log-details__ai-table-copy vox-btn"
            *ngIf="aiData.summary"
            (click)="copy(aiData.summary, tooltip)"
            ngbTooltip="{{ 'events.company-call-history.details.ai.copy-text.copied' | Translate }}"
            #tooltip="ngbTooltip"
            triggers="manual">
            <i class="icon-small-copy-outline"></i>
          </button>
        </th>
        <td
          *ngIf="aiData.summary; else empty"
          colspan="2">
          {{ aiData.summary }}
        </td>
      </tr>
      <tr>
        <th>
          <b>{{ "events.company-call-history.details.ai.headers.transcription" | Translate }}</b>
          <button
            class="call-log-details__ai-table-copy vox-btn"
            *ngIf="aiData.transcription"
            (click)="copy(aiData.transcription, tooltip)"
            ngbTooltip="{{ 'events.company-call-history.details.ai.copy-text.copied' | Translate }}"
            #tooltip="ngbTooltip"
            triggers="manual">
            <i class="icon-small-copy-outline"></i>
          </button>
        </th>
        <td
          *ngIf="aiData.transcription; else empty"
          colspan="2">
          {{ aiData.transcription }}
        </td>
      </tr>
    </tbody>
  </table>
</div>

<!-- TEMPLATES -->
<ng-template #empty>
  <td>-</td>
</ng-template>

<ng-template
  #sentiment
  let-ai="ai">
  <ng-container *ngIf="ai.isProcessing">
    <div
      disabled
      class="company-call-history-table__cell-ladda"
      [ladda]="true"
      data-spinner-size="22"
      data-style="zoom-in"
      data-spinner-color="black"></div>
  </ng-container>
  <ng-container *ngIf="!ai.isProcessing && ai.hasData">
    <app-sentiment-score [score]="ai.sentimentScore"></app-sentiment-score>
  </ng-container>
  <ng-container *ngIf="!ai.isProcessing && !ai.hasData">
    <i class="icon-big-robot"></i>
  </ng-container>
</ng-template>
